module.exports = __webpack_public_path__ + "static/media/dechets.0925748d.webp";